export const DISPLAY_MODE = {
    GRID: 'grid',
    PAGING: 'paging',
    SLIDER: 'slider'
};

export const GAME_SIZES = {
    EXTRA_SMALL: 'extraSmall',
    SMALL: 'small',
    MEDIUM: 'medium',
    LARGE: 'large'
};

export const GAME_WIDTHS = {
    [GAME_SIZES.EXTRA_SMALL]: {
        MOBILE: 65,
        DESKTOP: 65
    },
    [GAME_SIZES.SMALL]: {
        MOBILE: 90,
        DESKTOP: 120
    },
    [GAME_SIZES.MEDIUM]: {
        MOBILE: 120,
        DESKTOP: 150
    },
    [GAME_SIZES.LARGE]: {
        MOBILE: 150,
        DESKTOP: 200
    }
};
